export default ({ route, app }) => {
    // console.log(app.router.options.routes);
    // console.log("-----print route end------")
}
